import { useCallback } from "react";
import AddInIds from "@/constants/AddInIds";
import { useRemoveAddIn } from "@/hooks/addins/useRemoveAddIn";
import { DiagnosticView } from "@/models/DiagnosticView";

export function useDeleteView() {
  const removeAddIn = useRemoveAddIn<DiagnosticView>(AddInIds.diagnosticViews, "id");
  const deleteView = useCallback(
    async (viewId: string) => removeAddIn.mutateAsync({ delSearch: viewId }),
    [removeAddIn],
  );
  return { deleteView, isPending: removeAddIn.isPending };
}
